import React, { PropsWithChildren } from 'react';
import styles from './HideOverflow.module.scss';

export const HideOverflow = ({ children }: Props) => (
    <div className={styles.container}>
        {children}
    </div>
);

type Props = PropsWithChildren<Record<never, never>>;